import React from 'react'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close';

import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'

import TextField from '@mui/material/TextField'
import * as yup from 'yup'
import { useFormik } from 'formik'
import { getBillingManualOtherDeductions } from 'utils/otherDeductionColumns'


const validationSchema = yup.object({
    billed_to: yup.string().required('Billed To is required'),
    store: yup.string().required('Store is required'),
    admin_cost: yup.number().required('Administrative Cost is required'),
    rebate: yup.number().required('Rebate is required'),
    vat: yup.number().required('VAT is required'),
    withholding_tax: yup.number().required('WTX is required'),
    salary_deduction: yup.number().required('Salary Deduction is required'),
    meal_allowance: yup.number().required('Meal Allowance is required'),
    other_deductions: yup.string().required("Others is required"),
    soa_number: yup.string().required('SOA Number is required'),
});

export default function ({ open, onClose, billingDetails = {}, onUpdate = () => { } }) {
    const manualOtherDeductions = getBillingManualOtherDeductions(billingDetails)

    let initialValues = {
        billed_to: billingDetails.billed_to,
        store: billingDetails.store,
        admin_cost: billingDetails.admin_cost,
        rebate: billingDetails.rebate,
        vat: billingDetails.vat,
        withholding_tax: billingDetails.withholding_tax,
        salary_deduction: billingDetails.salary_deduction,
        meal_allowance: billingDetails.meal_allowance,
        other_deductions: manualOtherDeductions,
        soa_number: billingDetails.soa_number || '',
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            //Handle form submission
            onUpdate(values)
        },
    });


    return <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{

        }}
    >
         <DialogTitle id="alert-dialog-title" >
            <Stack direction='row' justifyContent="space-between">
                Edit Billing Details
                <IconButton
          onClick={onClose}
          size="small"
          sx={{
            color: '#6b7280',
            '&:hover': { bgcolor: '#f3f4f6' }
          }}
        >
          <CloseIcon />
        </IconButton>
            </Stack>
        </DialogTitle>
        <DialogContent sx={{ width: '35vw' }}>
            <Box sx={{ width: '100%' }}>

                <form onSubmit={formik.handleSubmit}>

                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                        <TextField
                            size='small'
                            label="SOA No."
                            name="soa_number"
                            value={formik.values.soa_number}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.soa_number && Boolean(formik.errors.soa_number)}
                            helperText={formik.touched.soa_number && formik.errors.soa_number}
                            fullWidth
                            sx={{
                                '& input::placeholder': {
                                    fontSize: '5px',
                                    opacity: 0.8,
                                },
                            }}
                        />
                        <TextField
                            size='small'
                            label="Billed To"
                            name="billed_to"
                            value={formik.values.billed_to}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.billed_to && Boolean(formik.errors.billed_to)}
                            helperText={formik.touched.billed_to && formik.errors.billed_to}
                            fullWidth
                            sx={{
                                '& input::placeholder': {
                                    fontSize: '5px',
                                    opacity: 0.8,
                                },
                            }}
                        />

                        <TextField
                            size='small'
                            label="Store"
                            name="store"
                            value={formik.values.store}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.store && Boolean(formik.errors.store)}
                            helperText={formik.touched.store && formik.errors.store}
                            fullWidth
                        />

                        <TextField
                            size='small'
                            label="Administrative Cost"
                            name="admin_cost"
                            type='number'
                            value={formik.values.admin_cost}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.admin_cost && Boolean(formik.errors.admin_cost)}
                            helperText={formik.touched.admin_cost && formik.errors.admin_cost}
                            fullWidth
                        />

                        <TextField
                            size='small'
                            label="Rebate"
                            name="rebate"
                            type='number'
                            value={formik.values.rebate}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.rebate && Boolean(formik.errors.rebate)}
                            helperText={formik.touched.rebate && formik.errors.rebate}
                            fullWidth
                        />

                        <TextField
                            size='small'
                            label="VAT (12%)"
                            name="vat"
                            type='number'
                            value={formik.values.vat}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.vat && Boolean(formik.errors.vat)}
                            helperText={formik.touched.vat && formik.errors.vat}
                            fullWidth
                        />

                        <TextField
                            size='small'
                            label="WTX"
                            name="withholding_tax"
                            type='number'
                            value={formik.values.withholding_tax}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.withholding_tax && Boolean(formik.errors.withholding_tax)}
                            helperText={formik.touched.withholding_tax && formik.errors.withholding_tax}
                            fullWidth
                        />


                        <TextField
                            size='small'
                            label="Salary Deduction"
                            name="salary_deduction"
                            type='number'
                            value={formik.values.billing_deduction}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.billing_deduction && Boolean(formik.errors.billing_deduction)}
                            helperText={formik.touched.billing_deduction && formik.errors.billing_deduction}
                            fullWidth
                        />

                        <TextField
                            size='small'
                            label="Meal Allowance"
                            name="meal_allowance"
                            type='number'
                            value={formik.values.meal_allowance}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.meal_allowance && Boolean(formik.errors.meal_allowance)}
                            helperText={formik.touched.meal_allowance && formik.errors.meal_allowance}
                            fullWidth
                        />

                        <TextField
                            size='small'
                            label="Other deductions"
                            name="others"
                            type='number'
                            value={formik.values.others}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.others && Boolean(formik.errors.others)}
                            helperText={formik.touched.others && formik.errors.others}
                            fullWidth
                        />


                        <Button
                            type="submit"
                            variant="contained"
                            sx={{ mt: 2 }}
                            disabled={formik.isSubmitting}

                        >
                            Submit
                        </Button>
                    </Box>
                </form>

            </Box>

        </DialogContent>

    </Dialog>
}


